import React, { useEffect, useState } from 'react'
import callApi from 'services/api'
import {
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatDate } from 'utils/DateFormatter'
import { loadingState } from 'global/LoaderState'
import { useRecoilState, useSetRecoilState } from 'recoil'
import AddDelinquency from '../delinquency/AddDelinquency_org'
import { UserState } from 'global/UserState'
import { useLocation } from 'react-router-dom'
import FirTable from '../delinquency/FirTable'
import { Accordion } from 'react-bootstrap'
import { BsCaretRightFill } from 'react-icons/bs'
import { TiThList } from 'react-icons/ti'
import DeTable from '../delinquency/DETable'
import AcrTable from '../delinquency/ACRTable'
import { useNavigate } from "react-router-dom";
import { AiOutlineSafetyCertificate } from 'react-icons/ai'

const AdminEmployeeDeliquency = () => {
  const [showModal, setShowModal] = useState(false)
  const { state } = useLocation()
  const location = useLocation();
  const item = location.state?.item;
  const data =location.state?.data;
  const unitName =location.state?.unitName
  const [user] = useRecoilState(UserState)
  const navigate = useNavigate();
  const loader = useSetRecoilState(loadingState)
  const [loading, setLoading] = useState(false)
  const [selectedEmpId, setSelectedEmpId] = useState(null)
  const [editingData, setEditingData] = useState()
  const [error, setError] = useState(null)
  const [empList, setEmpList] = useState([])
  const [deliquencyList, setDeliquencyList] = useState([])

  const getDeliquency = async (search) => {
    try {
      loader(true)
      setLoading(true)
      setError(null)
      const params = new URLSearchParams({
        search: search,
        search_field: 'empId',
        page: '-1',
        limit: '10',
        ...(item && { employeeId: item }),
      })
      const response = await callApi(
        `filtermaster/employee/deliquency/${item}/${data._id}`,
        'GET',
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log('navigate to', path)
      )

      if (response.success) {
        const payload = response?.body || []


        setDeliquencyList(payload)
      }
    } catch (err) {
      setError(err.message || 'Failed to load employees')
    } finally {
      loader(false)
      setLoading(false)
    }
  }

  const handleOpenModal = (data = null) => {
    setEditingData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setEditingData(null)
    setShowModal(false)
  }

  useEffect(() => {
    const { data } = state || {}
        const enrichedEmployee = {
        ...data,
        dob: formatDate(data?.dob), 
      }
      setEmpList([enrichedEmployee])

    if (data) {
      setSelectedEmpId(data?.id)
      getDeliquency(data?.id)
    }
  }, [state])

  const renderRows = () => {
    if (!empList || empList?.length === 0) {
      return (
        <tr>
          <td colSpan={7} className="p-3 text-start">
            No Delinquency
          </td>
        </tr>
      )
    }

    return empList?.map((item) => (
      <tr key={item.id}>
        <th className="text-center">{item.empCode}</th>
        <th className="text-center">{item.name}</th>
        <th className="text-center">{item.dob}</th>
        <th className="text-center">{item.rankName}</th>
        <th className="text-center">{item.beltNumber}</th>
        <th className="text-center">{item.postingName}</th>
      </tr>
    ))
  }

  return (
    <div className="container">
      <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
         <div className="d-flex align-items-center">
                      <button
                        className="btn btn-link text-white"
                        onClick={() => navigate(-1)}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </button>
                      <h5 className="card-title text-white m-0">Delinquencies</h5>
                    </div>
        <h6 className="card-title p-3 mt-1 text-white text-sm">
          Department : {user.unit || ''}
          {user.subUnit ? ` | ${user.subUnit}` : `${unitName}`}
        </h6>
      </div>
      <div className="card-body ms-3">
        <>
          <div className="table-responsive mt-4">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="text-center ">Unique Id</th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Date Of Birth</th>
                  <th className="text-center">Rank</th>
                  <th className="text-center">Belt Number</th>
                  <th className="text-center">Posting</th>
                </tr>
              </thead>
              <tbody>{renderRows()}</tbody>
            </table>
          </div>

          {deliquencyList.length == 0 && (
            <div>
              <h5>
                <span className="me-3">
                  <AiOutlineSafetyCertificate />
                </span>
                No Deliquency
              </h5>
            </div>
          )}

          {deliquencyList.length > 0 && (
            <div>
              <h5>
                <span className="me-3">
                  <TiThList />
                </span>
                List of Deliquencies:
              </h5>
              <span className="text-muted text-sm">
                No. of Deliquencies : {deliquencyList.length}
              </span>
            </div>
          )}

          <Accordion alwaysOpen>

            {deliquencyList.map((item, idx) => (
              <Accordion.Item eventKey={String(idx)} key={item.id || idx}>
                <Accordion.Header>
                  {idx+1}
                  <BsCaretRightFill />
                  {item.typeOfdeliquency === 'fir' && (
                    <div className="d-flex align-items-center">
                      <span className="ms-2">
                        Criminal Case
                      </span>
                    </div>
                  )}
                  {item.typeOfdeliquency === 'de' && (
                    <div className="d-flex align-items-center">
                      {/* <BsCaretRightFill /> */}
                      <span className="ms-2">Departmental Action</span>
                    </div>
                  )}
                  {item.typeOfdeliquency === 'acr' && (
                    <div className="d-flex align-items-center">
                      {/* <BsCaretRightFill />  */}
                      <span className="ms-2">Adverse Entry in ACR</span>
                    </div>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  {item.typeOfdeliquency === 'fir' && (
                    <FirTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}

                  {item.typeOfdeliquency === 'de' && (
                    <DeTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}
                  {item.typeOfdeliquency === 'acr' && (
                    <AcrTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          <AddDelinquency
            showModal={showModal}
            empId={editingData}
            onSuccess={() => getDeliquency(selectedEmpId)}
            handleCloseModal={handleCloseModal}
          />
        </>
      </div>
    </div>
  )
}

export default AdminEmployeeDeliquency
